import React, { useEffect, useState } from 'react';
import { StepsFooter, StepsHeader } from './components';
import { useSteps, withStepsProvider } from './lib';
import classNames from 'classnames';
import { StepsComponentProps } from './interfaces';
import './Steps.scss';

const StepsContent: React.FC<StepsComponentProps> = (props) => {
    const {
        headerClassName,
        footerClassName,
        className,
        submitLabel,
        footerVisible = true,
        nextLabel = 'Next',
        previousLabel = 'Previous',
        headerStepLineClassName,
        headerStepLabelClassName,
        defaultStepNumber = 0,
    } = props;

    const { steps, stepNumber, setStepNumber } = useSteps();
    const filteredSteps = steps.filter((step) => !!step);

    const [rendered, setRendered] = useState<boolean>(false);

    useEffect(() => {
        setTimeout(() => {
            if (defaultStepNumber) {
                setStepNumber(defaultStepNumber);
            }
            setRendered(true);
        }, 300);
    }, []);

    return (
        <div className={classNames('feature-steps', { rendered }, className)}>
            <StepsHeader
                className={headerClassName}
                headerStepLabelClassName={headerStepLabelClassName}
                headerStepLineClassName={headerStepLineClassName}
            />
            <div className='feature-steps__external-wrapper'>
                <div
                    className='feature-steps__internal-wrapper'
                    style={{
                        width: `${filteredSteps.length * 100}%`,
                        transform: `translate(-${stepNumber * (100 / filteredSteps.length)}%)`,
                    }}
                >
                    {filteredSteps.map((step, index) => {
                        return (
                            <div
                                key={index}
                                className={classNames('feature-steps__step-wrapper', {
                                    none: stepNumber !== index,
                                })}
                                style={{
                                    width: `${100 / steps.length}%`,
                                }}
                            >
                                <div className='feature-steps__step-content-wrapper'>{step}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <StepsFooter
                className={footerClassName}
                submitLabel={submitLabel}
                footerVisible={footerVisible}
                nextLabel={nextLabel}
                previousLabel={previousLabel}
            />
        </div>
    );
};

export const Steps = withStepsProvider(StepsContent);
